import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { ITableObject } from "../../models/storeModels/ITableObject";
import { logout } from "../../features/auth";


const initialState: ITableObject = {
    printButtonClicked: false,
    mapSize: {
        height: '298px',
        width: '100%'
    },
    tableObjectIsLoadingState: {
        objectInfo: null,
        tableObjectsStructure: null,
        loadingCoords: false,
        loadingStructure: false,
        loadingData: false
    }
}

export const tableObjectSlice = createSlice({
    name: 'tableObject',
    initialState,
    reducers: {
        setTableObjectMapSize(state, action: PayloadAction<any>) {
            state.mapSize.height = action.payload.height
            state.mapSize.width = action.payload.width
        },
        setTableObjectIsLoadingState(state, action: PayloadAction<any>) {
            const { loadingStructure, loadingData } = action.payload
            state.tableObjectIsLoadingState.loadingStructure = loadingStructure
            state.tableObjectIsLoadingState.loadingData = loadingData
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { setTableObjectMapSize, setTableObjectIsLoadingState } = tableObjectSlice.actions
export const tableObjectReducer = tableObjectSlice.reducer;
